export default {"src":"/_next/static/media/jpy.4adc32fd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};